import { render } from "./ViewTasks.vue?vue&type=template&id=8078cba8&scoped=true"
import script from "./ViewTasks.vue?vue&type=script&lang=js"
export * from "./ViewTasks.vue?vue&type=script&lang=js"

import "./ViewTasks.vue?vue&type=style&index=0&id=8078cba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8078cba8"]])

export default __exports__